import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxModalDraggableDirective } from '../../../directives/draggable.directive';

@Component({
  selector: 'app-modal-first-faq-video',
  templateUrl: './modal-first-faq-video.component.html',
  styleUrls: ['./modal-first-faq-video.component.scss']
})
export class ModalFirstFaqVideoComponent implements OnInit {
  public modalDirective: NgxModalDraggableDirective;
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }
  constructor(

    public bsModalRef: BsModalRef,
  ) { }

  ngOnInit(): void {
  }

}
